/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateSupplierDto,
  SupplierDto,
  SuppliersResponseDto,
  UpdateSupplierDto,
} from '../models/index';
import {
    CreateSupplierDtoFromJSON,
    CreateSupplierDtoToJSON,
    SupplierDtoFromJSON,
    SupplierDtoToJSON,
    SuppliersResponseDtoFromJSON,
    SuppliersResponseDtoToJSON,
    UpdateSupplierDtoFromJSON,
    UpdateSupplierDtoToJSON,
} from '../models/index';

export interface CreateSupplierRequest {
    createSupplierDto: CreateSupplierDto;
}

export interface DeleteSupplierByIdRequest {
    id: string;
}

export interface GetAllSuppliersRequest {
    page: number;
    query?: string;
    startDate?: string;
    endDate?: string;
    isConfirmed?: boolean;
    orderBy?: Array<string>;
    pageSize?: number;
}

export interface GetSupplierByEmailRequest {
    email: string;
}

export interface GetSupplierByIdRequest {
    id: string;
}

export interface GetSupplierByPhoneNumberRequest {
    phoneNumber: string;
}

export interface UpdateSupplierRequest {
    id: string;
    updateSupplierDto: UpdateSupplierDto;
}

/**
 * 
 */
export class SupplierServiceApi extends runtime.BaseAPI {

    /**
     * Creates supplier in database
     */
    async createSupplierRaw(requestParameters: CreateSupplierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplierDto>> {
        if (requestParameters['createSupplierDto'] == null) {
            throw new runtime.RequiredError(
                'createSupplierDto',
                'Required parameter "createSupplierDto" was null or undefined when calling createSupplier().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/supplier`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSupplierDtoToJSON(requestParameters['createSupplierDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierDtoFromJSON(jsonValue));
    }

    /**
     * Creates supplier in database
     */
    async createSupplier(requestParameters: CreateSupplierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplierDto> {
        const response = await this.createSupplierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes supplier by ID
     */
    async deleteSupplierByIdRaw(requestParameters: DeleteSupplierByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplierDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteSupplierById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/supplier/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierDtoFromJSON(jsonValue));
    }

    /**
     * Deletes supplier by ID
     */
    async deleteSupplierById(requestParameters: DeleteSupplierByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplierDto> {
        const response = await this.deleteSupplierByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches all suppliers, and optionally filtered by confirmation status, date range, etc.
     */
    async getAllSuppliersRaw(requestParameters: GetAllSuppliersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuppliersResponseDto>> {
        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling getAllSuppliers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        if (requestParameters['isConfirmed'] != null) {
            queryParameters['isConfirmed'] = requestParameters['isConfirmed'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/supplier`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuppliersResponseDtoFromJSON(jsonValue));
    }

    /**
     * Fetches all suppliers, and optionally filtered by confirmation status, date range, etc.
     */
    async getAllSuppliers(requestParameters: GetAllSuppliersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuppliersResponseDto> {
        const response = await this.getAllSuppliersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets supplier by email address
     */
    async getSupplierByEmailRaw(requestParameters: GetSupplierByEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplierDto>> {
        if (requestParameters['email'] == null) {
            throw new runtime.RequiredError(
                'email',
                'Required parameter "email" was null or undefined when calling getSupplierByEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/supplier/email/{email}`.replace(`{${"email"}}`, encodeURIComponent(String(requestParameters['email']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierDtoFromJSON(jsonValue));
    }

    /**
     * Gets supplier by email address
     */
    async getSupplierByEmail(requestParameters: GetSupplierByEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplierDto> {
        const response = await this.getSupplierByEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets full supplier by ID
     */
    async getSupplierByIdRaw(requestParameters: GetSupplierByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplierDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getSupplierById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/supplier/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierDtoFromJSON(jsonValue));
    }

    /**
     * Gets full supplier by ID
     */
    async getSupplierById(requestParameters: GetSupplierByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplierDto> {
        const response = await this.getSupplierByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets supplier by phone number
     */
    async getSupplierByPhoneNumberRaw(requestParameters: GetSupplierByPhoneNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplierDto>> {
        if (requestParameters['phoneNumber'] == null) {
            throw new runtime.RequiredError(
                'phoneNumber',
                'Required parameter "phoneNumber" was null or undefined when calling getSupplierByPhoneNumber().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/supplier/phone/{phoneNumber}`.replace(`{${"phoneNumber"}}`, encodeURIComponent(String(requestParameters['phoneNumber']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierDtoFromJSON(jsonValue));
    }

    /**
     * Gets supplier by phone number
     */
    async getSupplierByPhoneNumber(requestParameters: GetSupplierByPhoneNumberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplierDto> {
        const response = await this.getSupplierByPhoneNumberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates supplier in DB (including approval/rejection and role management)
     */
    async updateSupplierRaw(requestParameters: UpdateSupplierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplierDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateSupplier().'
            );
        }

        if (requestParameters['updateSupplierDto'] == null) {
            throw new runtime.RequiredError(
                'updateSupplierDto',
                'Required parameter "updateSupplierDto" was null or undefined when calling updateSupplier().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/supplier/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSupplierDtoToJSON(requestParameters['updateSupplierDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierDtoFromJSON(jsonValue));
    }

    /**
     * Updates supplier in DB (including approval/rejection and role management)
     */
    async updateSupplier(requestParameters: UpdateSupplierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplierDto> {
        const response = await this.updateSupplierRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
